import { EmployeeServicePath, VACATIONS } from "utils/constants";
import EditLeaves from "./Edit";
import pemissions from "app/permissions";

export const resources = {
  isMenu: false,
  name: EmployeeServicePath + "edit/" + VACATIONS + "/:id",
  title: "Редакция на отпуск",
  custom: <EditLeaves />,
  permission: pemissions.canUpdateLeaveRequests,
};
